import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import setCurrentShipTo from "@insite/client-framework/Store/Context/Handlers/SetCurrentShipTo";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
interface SetAddressParameters {
    shipTo: ShipToModel,
}

// Internal parameters
interface Props {
    shipToModel: ShipToModel,
}

type HandlerType = Handler<SetAddressParameters, Props>;

const SetShipTo: HandlerType = ({ parameter, dispatch }) => {
    dispatch(setCurrentShipTo({
        shipToId: parameter.shipTo.id
    }));
}

const UpdateState: HandlerType = ({ parameter, dispatch }) => {
    (dispatch as customDispatch)({
        type: "Affinity/CreateAccount/SetAddress",
        address: parameter.shipTo,
    });
}

const Tracking: HandlerType = props => {
    //
}

export const chain = [
    SetShipTo,
    UpdateState,
    Tracking,
];

const setAddress = createHandlerChainRunner(chain, "SetAddress");
export default setAddress;